import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient, Session } from '@benzinga/session';
import { ReviewForm } from '../entities';
import { ContentEnvironment } from '../environment';

export class ContentRestfulMoney extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ContentEnvironment).url, session);
  }

  getPoll = (id: number): SafePromise<any> => {
    const url = this.URL(`zing/polls/${id}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  postPollSubmission = (id: number, data: any): SafePromise<any> => {
    const url = this.URL(`zing/polls/${id}/submit`);
    return this.post(url, data, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  submitReview = (form: ReviewForm, review: any): Promise<any> => {
    const url = this.URL(`rating-forms/${form.rating_form_id}/entry`);
    return this.post(
      url,
      {
        form: form.rating_form_id,
        ...review,
      },
      { allowsAnonymousAuth: true, credentials: 'same-origin' },
    );
  };
}
